import { FC, useContext } from 'react';
import Icon from '@common/assets';
import { useUserInfo } from '@repository/auth/useUserInfo';
import { calendarPcListKeys } from '@repository/calendar/useCalendar';
import { BigCalendarContext, CalendarContext } from '../../contextWrap';
import { JobPostStatusType } from '@domain/constant/JobPostStatusType';
import Colors from '@domain/constant/colors';
import { queryClient } from '@utils/queryClient';

import classnames from 'classnames/bind';
import styles from './calendarHeader.module.scss';
const cx = classnames.bind(styles);

interface OptionAreaProps {
  setLoginModalVisible: (visible: boolean) => void;
}

const OptionArea: FC<OptionAreaProps> = ({ setLoginModalVisible }) => {
  const { filter } = useContext(CalendarContext);
  const { filterCondition } = useContext(BigCalendarContext);

  const { data: userData } = useUserInfo();
  const isLogin = !!userData?.id;

  const onClickAccBtn = () => {
    filterCondition.setAIScreeningYn(!filterCondition.aiScreeningYn);
  };

  const onClickBookmark = () => {
    if (!isLogin) {
      setLoginModalVisible(true);
      return;
    }
    filterCondition.setBookmarkYn(!filterCondition.bookmarkYn);
    //북마크 on시에만 calendar api 호출
    if (!filterCondition.bookmarkYn) queryClient.refetchQueries(calendarPcListKeys(filter.latestFilter));
  };

  const onClickJobPostStatus = (status: JobPostStatusType | null) => {
    filterCondition.setJobPostStatus(status);
  };

  return (
    <div className={cx('optionArea')}>
      <a className={cx('btn', 'acc', { on: filterCondition.aiScreeningYn })} role="button" onClick={onClickAccBtn}>
        {filterCondition.aiScreeningYn ? (
          <Icon name="businessFilledLight" width={16} height={16} fill={Colors.C_GREEN_150} />
        ) : (
          <Icon name="businessLight" width={16} height={16} fill={Colors.C_JOBDA_BLACK} />
        )}
        역량검사 활용 공고
      </a>
      {/* 북마크 버튼 */}
      <a className={cx('btn', 'bookmark', { on: filterCondition.bookmarkYn })} role="button" onClick={onClickBookmark}>
        {filterCondition.bookmarkYn ? (
          <Icon name="bookmarkLightFilled" width={16} height={16} fill={Colors.C_GREEN_150} />
        ) : (
          <Icon name="bookmarkLight" width={16} height={16} fill={Colors.C_COOL_GRAY_80} />
        )}
        북마크
      </a>

      {/* 필터 옵션 영역 */}
      <div className={cx('optionWrap')}>
        {/* 필터 옵션 버튼 */}
        {/* [D] 선택된 경우 'on' 클래스 추가 */}
        <a
          className={cx('btnOption', { on: filterCondition.jobPostStatus === null })}
          role="button"
          onClick={() => onClickJobPostStatus(null)}
        >
          전체
        </a>
        <a
          className={cx('btnOption', { on: filterCondition.jobPostStatus === 'END' })}
          role="button"
          onClick={() => onClickJobPostStatus('END')}
        >
          마감
        </a>
        <a
          className={cx('btnOption', { on: filterCondition.jobPostStatus === 'START' })}
          role="button"
          onClick={() => onClickJobPostStatus('START')}
        >
          시작
        </a>
        <a
          className={cx('btnOption', { on: filterCondition.jobPostStatus === 'ROLLING' })}
          role="button"
          onClick={() => onClickJobPostStatus('ROLLING')}
        >
          상시
        </a>
      </div>
    </div>
  );
};

export default OptionArea;
